import React, {Component} from "react";
import Column from "@amzn/meridian/column";
import {DEVICE_MANAGEMENT_ROUTES} from "../util/RouteConstants";
import SelectLayout, {NavigationRoutes} from "../util/SelectLayout";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/Constants";

class DeviceManagementPage extends Component {
    render() {
        return (
            <Column spacingInset={"small large"} spacing={"medium"}>
                <PageHeader {...PAGE_HEADERS.DEVICE_MANAGEMENT}> </PageHeader>
                <SelectLayout routes={DEVICE_MANAGEMENT_ROUTES} location={this.props.location} history={this.props.history}/>
                <NavigationRoutes routes={DEVICE_MANAGEMENT_ROUTES}/>
            </Column>
        )
    }
}

export default  DeviceManagementPage



// WEBPACK FOOTER //
// ./src/components/devicemanagement/DeviceManagementPage.js